import { render, staticRenderFns } from "./createRecommendation.vue?vue&type=template&id=316609e2&scoped=true"
import script from "./createRecommendation.vue?vue&type=script&lang=js"
export * from "./createRecommendation.vue?vue&type=script&lang=js"
import style0 from "./createRecommendation.vue?vue&type=style&index=0&id=316609e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316609e2",
  null
  
)

export default component.exports